import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 text-center"
      style={{ background: "var(--bg)", color: "var(--text-1)" }}
    >
      <h1 className="text-2xl font-semibold">Página no encontrada</h1>
      <Link to="/" className="underline" style={{ color: "var(--brand-ink)" }}>
        Volver al inicio
      </Link>
    </div>
  );
}
